import { APP_INITIALIZER, Inject, Injectable, Injector, DOCUMENT } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BootstrapperBase } from '@trustedshops/tswp-core-common';
import { ProductFeatureUpgradeButtonComponent } from './product-feature-upgrade-button.component';

@Injectable()
export class ProductFeatureUpgradeButtonBootstrapper implements BootstrapperBase {
  public constructor(
    private readonly _injector: Injector,
    @Inject(DOCUMENT) private readonly _document: Document
  ) {}

  public async initialize(): Promise<void> {
    const defaultView = this._document.defaultView;
    if (!defaultView) {
      return;
    }
    const customElement = createCustomElement(ProductFeatureUpgradeButtonComponent, {
      injector: this._injector,
    });
    defaultView.customElements.define(
      ProductFeatureUpgradeButtonComponent.selector,
      customElement
    );
  }
}

export const ProductFeatureUpgradeButtonInitializer = [
  ProductFeatureUpgradeButtonBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: BootstrapperBase) => () => initializer.initialize(),
    deps: [ProductFeatureUpgradeButtonBootstrapper],
  },
];
